import { reducer as formReducer } from 'redux-form/immutable';

import { combineReducers, coreReducer, customizationReducer } from '@va/dashboard/reducers';
import apiReducer from './api';
import appReducer from './app';

export default combineReducers({
  form: formReducer,
  api: apiReducer,
  app: appReducer,
  core: coreReducer,
  customization: customizationReducer,
});
